<template>
     <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>

        <div class="row">
            <div class="col l12 s12">
                <h5>Cobranza por mes</h5>
            </div>
        </div>
        <div class="row">
            <div class="col s12 l12 card">
                <div class="row">
                    <div class="col l6 offset-l3 s12 input-field">
                        <inncosys-sucursales-select-name v-model="selectedStore" ></inncosys-sucursales-select-name >
                    </div>

               </div>
               <div class="row">
                    <div class="col l12 s12">
                        <div v-if="loadingResults" class="progress">
                            <div class="indeterminate"></div>
                        </div>

                        <div id="detalleOcupacionStacked">

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </main>
</template>

<script>
import Breadcrumbs from "../../components/commun/Breadcrumbs.vue";

import SucursalesSelectName from "../../components/commun/SucursalesSelectName.vue";

import * as Highcharts from "highcharts";

const moment = require("moment");
import { indicadorFacturacion } from "../../controllers/comercial/facturacion.js";
import {csvExport} from "../../controllers/commun/csv-export.js";
const csvExportInstance = new csvExport();
export default {
  mounted() {
    this.facturacionInstance = new indicadorFacturacion();
    this.getCobranzaPorMes("ALL");
  },
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSucursalesSelectName: SucursalesSelectName
  },
  data() {
    return {
      facturacionInstance: null,
      pathHistory: [
        { name: "Inicio", route: "/" },
        {
          name: "Reportes Directivos",
          route: "/reportes-directivos/ocupacion"
        },
        {
          name: "Cobranza por mes",
          route: "/reportes-directivos/cobranza-mes"
        }
      ],
      selectedStore: "",
      loadingResults: false
    };
  },
  methods: {
    getCobranzaPorMes(sucursal) {
      this.loadingResults = true;
      const vue = this;
      const series = [
        {
          name: "Por Cobrar",
          color: "#b71c1c",
          data: []
        },
        {
          name: "Pagado",
          color: "#1b5e20",
          data: []
        }
      ];
      this.facturacionInstance.getInvoicesData(sucursal).then(invoices => {
        const months = [];
        moment.locale("es-es");
        for (let i = 0; i < moment().month() + 1; i++) {
          const fechaMes = moment(moment().format(`YYYY-${i + 1}-01`));
          months.push(fechaMes.format("MMMM YYYY"));
          vue.facturacionInstance
            .calculateInvoicesDetailedAmmount(
              sucursal,
              fechaMes.valueOf(),
              moment().valueOf()
            )
            .then(resultObj => {
              const total =
                resultObj.hashMapCountResult.open +
                resultObj.hashMapCountResult.paid;
              const pOpen = parseFloat(
                ((resultObj.hashMapCountResult.open * 100) / total).toFixed(2)
              );
              const pPaid = parseFloat(
                ((resultObj.hashMapCountResult.paid * 100) / total).toFixed(2)
              );
              series[0].data.push({
                y: pOpen,
                money: resultObj.hashMapCountResult.open.formatMoney(2),
                totalFacturado: total.formatMoney(2),
                openInvoices: resultObj.openInvoices
              });
              series[1].data.push({
                y: pPaid,
                money: resultObj.hashMapCountResult.paid.formatMoney(2),
                totalFacturado: total.formatMoney(2)
              });
              vue.plot(series, months);
            });
        }
      });
      this.equiposPorFamilia = [];

      this.loadingResults = false;
      const vueInstance = this;
    },
    plot(series, months) {
      this.loadingResults = false;
      console.log(series);
      Highcharts.chart("detalleOcupacionStacked", {
        chart: {
          type: "column"
        },
        title: {
          text: "Cobranza por mes"
        },
        xAxis: {
          categories: months
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Facturación Total"
          },
          stackLabels: {
            enabled: true
          }
        },

        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            "{series.name}: ${point.money}<br/>Facturado: ${point.totalFacturado}"
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true
            }
          },
          series: {
            cursor: "pointer",
            point: {
              events: {
                click(event) {
                  csvExportInstance.downloadCSV({
                    filename: "open-invoices.csv",
                    data: this.openInvoices
                  });
                }
              }
            }
          }
        },
        series
      });
    }
  },
  watch: {
    selectedStore(value) {
      console.log("SUCURSAL", value);
      this.getCobranzaPorMes(value);
    }
  }
};
</script>
